import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeAlert, openAlert } from "redux/slices/alertSlice";

import axios from "axios";
import style from "css/myreservation.module.css";
import DailyCalendar from "./calendar/dailyCalendar";
import DepartmentStatus from "./component/departmentStatus";
import MyReservationInfo from "./component/myReservationInfo";

import moment from "moment";
import "moment/locale/ko";
import { useTranslation } from "react-i18next";
import NoticeAlert from "./component/noticeAlert";

function MyReservation() {
    const isNoticeActive = localStorage.getItem("noticeAlert");
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const userPayload = useSelector((state) => state.user);
    const calendarRangePayload = useSelector((state) => state.calendarRange);

    const [init, setInit] = useState(true);
    const [meetingScheduleList, setMeetingScheduleList] = useState([]);
    const [hotdeskingScheduleList, setHotdeskingScheduleList] = useState([]);
    const [meetingScheduleListForCalendar, setMeetingScheduleListForCalendar] = useState([]);
    const [hotdeskingScheduleListForCalendar, setHotdeskingScheduleListForCalendar] = useState([]);
    const [myInfo, setMyInfo] = useState({});
    const [colleagueList, setColleagueList] = useState([]);

    const [isMeetingLoading, setIsMeetingLoading] = useState(true);
    const [isHotdeskingLoading, setIsHotdeskingLoading] = useState(true);
    const [isColleagueLoading, setIsColleagueLoading] = useState(true);

    const getMeetingRoomSchedules = useCallback(() => {
        setIsMeetingLoading(true);
        let url = "/schedule/myschedulelist";
        let param = {
            params: {
                ACTIVE_START: moment().format("YYYY-MM-DD") + "T00:00:00",
                ACTIVE_END: moment().add(7, "days").format("YYYY-MM-DD") + "T00:00:00",
            },
        };

        axios
            .get(url, param)
            .then((res) => {
                if (res.status === 200) {
                    let schedules = [];
                    const dateArr = res.data.DATE;
                    for (let i = 0; i < dateArr.length; i++) {
                        const date = dateArr[i];
                        const d = res.data.DATA[date];

                        const tmp = d.map((data) => {
                            return data;
                        });
                        schedules.push(...tmp);
                    }
                    setMeetingScheduleList(schedules);
                }
            })
            .catch(() => {
                const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.ERROR_OCCURRED"),
                    submitEventHandler: () => {
                        dispatch(closeAlert());
                    },
                };
                dispatch(openAlert(obj));
            })
            .finally(() => setIsMeetingLoading(false))
    }, [dispatch, t])

    const getMeetingRoomSchedulesForCalendar = useCallback(() => {
        if (
            calendarRangePayload.ACTIVE_START !== "" &&
            calendarRangePayload.ACTIVE_END !== ""
        ) {
            let url = "/schedule/myschedulelist";
            let param = {
                params: {
                    ACTIVE_START: calendarRangePayload.ACTIVE_START + "T00:00:00",
                    ACTIVE_END: calendarRangePayload.ACTIVE_END + "T00:00:00",
                },
            };

            axios
                .get(url, param)
                .then((res) => {
                    if (res.status === 200) {
                        let schedules = [];
                        const dateArr = res.data.DATE;
                        for (let i = 0; i < dateArr.length; i++) {
                            const date = dateArr[i];
                            const d = res.data.DATA[date];

                            const tmp = d.map((data) => {
                                return {
                                    id: data.SCHEDULE_ID,
                                    // resourceId: data.SCHEDULE_TYPE,
                                    resourceId: "M",
                                    title: data.TITLE,
                                    start: data.START_DATETIME,
                                    end: data.END_DATETIME,
                                    backgroundColor: "#f4fcf9",
                                    borderColor: "#1cb691",
                                    // color: "#000",
                                    extendedProps: {
                                        resourceId: "M",
                                        ...data,
                                    },
                                };
                            });
                            schedules.push(...tmp);
                        }
                        setMeetingScheduleListForCalendar(schedules);
                    }
                })
                .catch(() => {
                    const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: t("MESSAGE.ERROR_OCCURRED"),
                        submitEventHandler: () => {
                            dispatch(closeAlert());
                        },
                    };
                    dispatch(openAlert(obj));
                })
        }
    }, [calendarRangePayload, dispatch, t]);

    const getHotDeskingSchedules = useCallback(() => {
        if (
            calendarRangePayload.ACTIVE_START !== "" &&
            calendarRangePayload.ACTIVE_END !== "" &&
            userPayload !== ""
        ) {
            setIsHotdeskingLoading(true);
            let url = "/hotdesking/book/list/my";
            let param = {
                params: {
                    start_dttm: moment().format("YYYY-MM-DD") + "T00:00:00",
                    end_dttm: moment().add(7, "days").format("YYYY-MM-DD") + "T00:00:00",
                    member_id: userPayload.id
                },
            };

            axios
                .get(url, param)
                .then(async (res) => {
                    if (res.status === 200) {
                        setHotdeskingScheduleList(res.data);
                    }
                })
                .catch(() => {
                    const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: t("MESSAGE.ERROR_OCCURRED"),
                        submitEventHandler: () => {
                            dispatch(closeAlert());
                        },
                    };
                    dispatch(openAlert(obj));
                })
                .finally(() => setIsHotdeskingLoading(false));
        }
    }, [calendarRangePayload, dispatch, t, userPayload]);

    const getHotDeskingSchedulesForCalendar = useCallback(() => {
        if (
            calendarRangePayload.ACTIVE_START !== "" &&
            calendarRangePayload.ACTIVE_END !== "" &&
            userPayload !== ""
        ) {
            let url = "/hotdesking/book/list/my";
            let param = {
                params: {
                    start_dttm: calendarRangePayload.ACTIVE_START + "T00:00:00",
                    end_dttm: calendarRangePayload.ACTIVE_END + "T00:00:00",
                    member_id: userPayload.id
                },
            };

            axios
                .get(url, param)
                .then(async (res) => {
                    if (res.status === 200) {
                        let schedules = res.data.map(book => {
                            return {
                                id: book.id,
                                resourceId: "H",
                                title: book.resource.title,
                                start: book.startDttm,
                                end: book.endDttm,
                                backgroundColor: "#f8ffdf",
                                borderColor: "#9cc60c",
                                extendedProps: {
                                    ...book,
                                    resourceId: "M",
                                },
                            }
                        })
                        setHotdeskingScheduleListForCalendar(schedules);
                    }
                })
                .catch(() => {
                    const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: t("MESSAGE.ERROR_OCCURRED"),
                        submitEventHandler: () => {
                            dispatch(closeAlert());
                        },
                    };
                    dispatch(openAlert(obj));
                })
                .finally(() => setIsHotdeskingLoading(false));
        }
    }, [calendarRangePayload, dispatch, t, userPayload]);

    const getMyColleague = useCallback(() => {
        setIsColleagueLoading(true);
        axios
            .get("/user/myColleague")
            .then((res) => {
                if (res.status === 200) {
                    setMyInfo(res.data.MY);
                    setColleagueList(res.data.DEPARTMENT);
                }
            })
            .catch(() => {
                const obj = {
                    title: t("MESSAGE.NOTIFICATION"),
                    content: t("MESSAGE.ERROR_OCCURRED"),
                    submitEventHandler: () => {
                        dispatch(closeAlert());
                    },
                };
                dispatch(openAlert(obj));
            })
            .finally(() => {
                setIsColleagueLoading(false);
            });
    }, [dispatch, t])


    useEffect(() => {
        if (userPayload.id !== '') {
            if (init) {
                getMeetingRoomSchedules();
                getHotDeskingSchedules();
                getMyColleague();
            }
            getMeetingRoomSchedulesForCalendar();
            getHotDeskingSchedulesForCalendar();
            if (init) setInit(false);
        }
    }, [getMeetingRoomSchedules, getMyColleague, userPayload.id, init, getHotDeskingSchedules, getMeetingRoomSchedulesForCalendar, getHotDeskingSchedulesForCalendar]);

    function splitSchedulesByDate(scheduleList, type) {
        const todayDate = new Date();
        todayDate.setHours(0, 0, 0, 0);

        // const past = [];
        const today = [];
        const future = [];

        scheduleList.length > 0 && scheduleList.forEach((schedule) => {
            const startTime = new Date(type === "M" ? schedule.START_DATETIME : schedule.startDttm);
            startTime.setHours(0, 0, 0, 0);

            if (startTime < todayDate) {
                // past.push(schedule);
            } else if (startTime.getTime() === todayDate.getTime()) {
                today.push(schedule);
            } else {
                future.push(schedule);
            }
        });

        return { today, future };
    }

    return (
        <div className={style.wrapper}>
            {(isNoticeActive === null || isNoticeActive !== 'false') && <NoticeAlert />}
            <div className={style.container}>
                <section className={style.section}>
                    <div className={style.section_title}>{t("LABEL.TITLE.MY_RESERVATION")}</div>
                    <div className={style.myreservation_container}>
                        <MyReservationInfo
                            hotdeskingScheduleList={splitSchedulesByDate(hotdeskingScheduleList, 'H')}
                            meetingScheduleList={splitSchedulesByDate(meetingScheduleList, 'M')}
                            isLoading={{ hotdesking: isHotdeskingLoading, meeting: isMeetingLoading }}
                        />
                    </div>
                </section>
                <section className={style.section}>
                    <div className={style.section_title}>{t("LABEL.TITLE.WEEK_MONTH_CALENDAR")}</div>
                    <div className={style.calendar_container}>
                        <DailyCalendar
                            scheduleList={meetingScheduleListForCalendar.concat(hotdeskingScheduleListForCalendar)}
                        />
                    </div>
                </section>
                <section className={style.section}>
                    <div className={style.section_title}>{t("LABEL.TITLE.DEPARTMENT_STATUS")}</div>
                    <div className={style.dept_container}>
                        <DepartmentStatus
                            myInfo={myInfo}
                            colleagueList={colleagueList}
                            isLoading={isColleagueLoading}
                        />
                    </div>
                </section>
            </div>
        </div>
    )
}

export default MyReservation
